import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InfoIcon } from 'lucide-react';
const ClientInformation = () => {
  const {
    register,
    formState: {
      errors
    },
    watch
  } = useFormContext();
  const existingClient = watch('clientInfo.existingClient');
  return <div className="space-y-8" data-id="element-549">
      {/* Introductory Statement */}
      <div className="bg-amber-50 p-5 rounded-lg border border-amber-200 mb-6" data-id="element-550">
        <p className="text-amber-900 leading-relaxed" data-id="element-551">
          The purpose of this questionnaire is to provide us with sufficient
          information to assist you in planning your estate and to get you
          thinking about certain aspects of your estate planning matters. This
          questionnaire does not replace the need for us to meet to discuss your
          estate planning in detail; this is only for discussion purposes at our
          meeting and to assist us in drafting your documents.
        </p>
      </div>

      <div className="space-y-6" data-id="element-552">
        {/* Existing Client */}
        <div data-id="element-553">
          <div className="flex items-center mb-2" data-id="element-554">
            <label className="text-navy-800 font-medium" data-id="element-555">
              Are you an existing client?
            </label>
          </div>
          <div className="flex items-center space-x-4 mb-4" data-id="element-556">
            <label className="inline-flex items-center" data-id="element-557">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('clientInfo.existingClient')} data-id="element-558" />
              <span className="ml-2" data-id="element-559">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-560">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('clientInfo.existingClient')} data-id="element-561" />
              <span className="ml-2" data-id="element-562">No</span>
            </label>
          </div>

          {/* Which lawyer - shown if existing client */}
          {existingClient === 'true' && <div className="mt-4" data-id="element-563">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-564">
                Which lawyer have you worked with?
                <span className="text-red-500 ml-1" data-id="element-565">*</span>
              </label>
              <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter the lawyer's name" {...register('clientInfo.existingLawyer')} data-id="element-566" />
            </div>}
        </div>

        {/* How did you hear about us - Changed to text box */}
        <div data-id="element-567">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-568">
            How did you hear about us?
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Please describe how you heard about our firm" {...register('clientInfo.referralSource')} data-id="element-569" />
        </div>

        {/* Full Legal Name */}
        <div data-id="element-570">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-571">
            Full Legal Name
            <span className="text-red-500 ml-1" data-id="element-572">*</span>
          </label>
          <input type="text" className={`w-full px-3 py-2 border ${errors.clientInfo?.fullName ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="Enter your full legal name" {...register('clientInfo.fullName')} data-id="element-573" />
          {errors.clientInfo?.fullName && <p className="text-red-500 text-sm mt-1" data-id="element-574">
              {errors.clientInfo.fullName.message as string}
            </p>}
          <p className="text-slate-500 text-sm mt-1" data-id="element-575">
            Please provide your full legal name as it appears on official
            documents.
          </p>
        </div>

        {/* Age */}
        <div data-id="element-576">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-577">
            Age
            <span className="text-red-500 ml-1" data-id="element-578">*</span>
          </label>
          <input type="number" className={`w-full px-3 py-2 border ${errors.clientInfo?.age ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="Enter your age" {...register('clientInfo.age')} data-id="element-579" />
          {errors.clientInfo?.age && <p className="text-red-500 text-sm mt-1" data-id="element-580">
              {errors.clientInfo.age.message as string}
            </p>}
        </div>

        {/* Marital Status */}
        <div data-id="element-581">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-582">
            Marital Status
            <span className="text-red-500 ml-1" data-id="element-583">*</span>
          </label>
          <select className={`w-full px-3 py-2 border ${errors.clientInfo?.maritalStatus ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} {...register('clientInfo.maritalStatus')} data-id="element-584">
            <option value="" data-id="element-585">Please select</option>
            <option value="married" data-id="element-586">Married</option>
            <option value="commonLaw" data-id="element-587">Common Law</option>
            <option value="divorced" data-id="element-588">Divorced</option>
            <option value="widowed" data-id="element-589">Widowed</option>
            <option value="single" data-id="element-590">Single</option>
          </select>
          {errors.clientInfo?.maritalStatus && <p className="text-red-500 text-sm mt-1" data-id="element-591">
              {errors.clientInfo.maritalStatus.message as string}
            </p>}
        </div>

        {/* Address */}
        <div data-id="element-592">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-593">
            Address
            <span className="text-red-500 ml-1" data-id="element-594">*</span>
          </label>
          <textarea className={`w-full px-3 py-2 border ${errors.clientInfo?.address ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} rows={3} placeholder="Enter your current address" {...register('clientInfo.address')} data-id="element-595" />
          {errors.clientInfo?.address && <p className="text-red-500 text-sm mt-1" data-id="element-596">
              {errors.clientInfo.address.message as string}
            </p>}
        </div>

        {/* Phone Number */}
        <div data-id="element-597">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-598">
            Phone Number
            <span className="text-red-500 ml-1" data-id="element-599">*</span>
          </label>
          <input type="tel" className={`w-full px-3 py-2 border ${errors.clientInfo?.phone ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="(123) 456-7890" {...register('clientInfo.phone')} data-id="element-600" />
          {errors.clientInfo?.phone && <p className="text-red-500 text-sm mt-1" data-id="element-601">
              {errors.clientInfo.phone.message as string}
            </p>}
        </div>

        {/* Email */}
        <div data-id="element-602">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-603">
            Email
            <span className="text-red-500 ml-1" data-id="element-604">*</span>
          </label>
          <input type="email" className={`w-full px-3 py-2 border ${errors.clientInfo?.email ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="your.email@example.com" {...register('clientInfo.email')} data-id="element-605" />
          {errors.clientInfo?.email && <p className="text-red-500 text-sm mt-1" data-id="element-606">
              {errors.clientInfo.email.message as string}
            </p>}
          <p className="text-slate-500 text-sm mt-1" data-id="element-607">
            We'll use this email to communicate with you about your documents.
          </p>
        </div>

        {/* Employment Information Section */}
        <div className="pt-4" data-id="element-608">
          <div className="flex items-center mb-2" data-id="element-609">
            <h3 className="text-lg font-medium text-navy-900" data-id="element-610">
              Employment Information
            </h3>
            <span className="text-red-500 ml-1" data-id="element-611">*</span>
            <div className="ml-2 group relative" data-id="element-612">
              <InfoIcon size={16} className="text-slate-500 cursor-help" data-id="element-613" />
              <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-navy-800 text-white text-xs p-3 rounded w-72 z-10" data-id="element-614">
                We are required to collect this information as part of 'Know
                Your Client' rules under professional regulatory requirements.
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-615">
            <p className="text-sm text-blue-800" data-id="element-616">
              <strong data-id="element-617">Required:</strong> We are required to collect this
              information as part of 'Know Your Client' rules under professional
              regulatory requirements.
            </p>
          </div>

          {/* Occupation */}
          <div className="mb-4" data-id="element-618">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-619">
              Occupation
              <span className="text-red-500 ml-1" data-id="element-620">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your occupation" {...register('clientInfo.occupation')} data-id="element-621" />
          </div>

          {/* Employer Name */}
          <div className="mb-4" data-id="element-622">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-623">
              Employer Name
              <span className="text-red-500 ml-1" data-id="element-624">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your employer's name" {...register('clientInfo.employerName')} data-id="element-625" />
          </div>

          {/* Business Address */}
          <div className="mb-4" data-id="element-626">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-627">
              Business Address
              <span className="text-red-500 ml-1" data-id="element-628">*</span>
            </label>
            <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter your business address" {...register('clientInfo.businessAddress')} data-id="element-629" />
          </div>

          {/* Business Phone */}
          <div className="mb-4" data-id="element-630">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-631">
              Business Phone
              <span className="text-red-500 ml-1" data-id="element-632">*</span>
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register('clientInfo.businessPhone')} data-id="element-633" />
          </div>
        </div>

        {/* Citizenship */}
        <div data-id="element-634">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-635">
            Citizenship(s)
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Canadian, American" {...register('clientInfo.citizenship')} data-id="element-636" />
          <p className="text-slate-500 text-sm mt-1" data-id="element-637">
            Please list all countries of citizenship. This information is
            important for tax and estate planning purposes.
          </p>
        </div>
      </div>
    </div>;
};
export default ClientInformation;